module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-office-forms ccm-page"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _c('Header'), (!_vm.loading) ? _c('main', [_vm._m(0), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.props) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main1-37 blog-entry-list"
  }, [_c('div', {
    staticClass: "ccm-block-page-list-wrapper"
  }, [_vm._m(1), _c('div', {
    staticClass: "ccm-block-page-list-pages"
  }, _vm._l((_vm.props), function(blogItem, i) {
    return _c('div', {
      key: i,
      staticClass: "ccm-block-page-list-page-entry"
    }, [_c('div', {
      staticClass: "ccm-block-page-list-page-entry-text"
    }, [_c('div', {
      staticClass: "ccm-block-page-list-title"
    }, [_c('router-link', {
      attrs: {
        "to": "/blog/" + blogItem.slug
      },
      domProps: {
        "innerHTML": _vm._s(blogItem.title.rendered)
      }
    })], 1), _c('div', {
      staticClass: "ccm-block-page-list-date"
    }, [_vm._v(_vm._s(blogItem.acf.date_in_all) + ", " + _vm._s(blogItem.acf.time_in_all))]), _c('div', {
      staticClass: "ccm-block-page-list-description",
      domProps: {
        "innerHTML": _vm._s(blogItem.excerpt.rendered)
      }
    })])])
  }))])])]), _c('div', {
    staticClass: "col-sm-3 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main2-38 block-sidebar-wrapped"
  }, [_c('div', {
    staticClass: "ccm-block-topic-list-wrapper"
  }, [_vm._m(2), _c('ul', {
    staticClass: "ccm-block-topic-list-list"
  }, _vm._l((_vm.props_category), function(blogItem1, i) {
    return _c('li', {
      key: i
    }, [_c('router-link', {
      attrs: {
        "to": "/topic/" + blogItem1.slug
      }
    }, [_vm._v(_vm._s(blogItem1.name))])], 1)
  }))])]), _vm._m(3)])])]) : _vm._e()])]), _c('div', {
    staticClass: "saprater-mian"
  })]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Blog")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ccm-block-page-list-rss-feed",
    attrs: {
      "href": "https://updikeortho.com/index.php/rss/blog",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-rss"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ccm-block-topic-list-header"
  }, [_c('h5', [_vm._v("Topics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ccm-custom-style-container ccm-custom-style-main2-39 block-sidebar-padded"
  }, [_c('div', {
    staticClass: "ccm-block-date-navigation-wrapper"
  }, [_c('div', {
    staticClass: "ccm-block-date-navigation-header"
  }, [_c('h5', [_vm._v("Archives")])]), _vm._v("None.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cac72ee","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/blog/blog.pug
// module id = 544
// module chunks = 1